module.exports = __webpack_public_path__ + "static/img/tsg.ee23f85.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/tsg.gif
// module id = Kz9z
// module chunks = 1